import React, { useCallback, useState } from 'react'
import Loading from '../../DAIComponents/Common/Loading'
import useAutomationContext from '../../hooks/useAutomationContext'
import { convertToLocaleDate } from '../../utils/timezone'
import { useUsermaven } from '@usermaven/react'
import CreateAutomationSidePanel from './CreateAutomationSidePanel'
import UseAIModal from './UseAIModal'
import { Table, Column, TableButton } from '../../DAIComponents/Table/DAITable'
import { AutomationComplex } from './AutomationTypes'
import { TemplateContextProvider } from '../../contexts/templateContext'

export default function AutomationTable() {
  const { loading, automations } = useAutomationContext()
  const { track } = useUsermaven()
  const [modalOpen, setModalOpen] = useState(false)
  const [createOpen, setCreateOpen] = useState(false)

  const openAIPopup = useCallback(async () => {
    setModalOpen(true)
    await track('AI_Popup_Opened')
  }, [])

  const createNew = useCallback(() => {
    setCreateOpen(true)
  }, [])

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loading />
      </div>
    )
  }

  return (
    <>
      <UseAIModal
        openModal={() => setModalOpen(true)}
        closeModal={() => setModalOpen(false)}
        isOpen={modalOpen}
      />
      {createOpen && (
        <TemplateContextProvider>
          <CreateAutomationSidePanel
            onClose={() => {
              setCreateOpen(false)
            }}
          />
        </TemplateContextProvider>
      )}
      {/* <div className="hidden md:ml-4 md:flex md:items-center mb-4">
        <button
          onClick={openAIPopup}
          type="button"
          className="ml-6 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        >
          Use AI
        </button>
      </div> */}
      <Table<AutomationComplex>
        loading={loading}
        onAdd={createNew}
        data={automations || []}
        title="All Automations"
        description="A list of all automations in your account."
      >
        <Column<AutomationComplex> title="Automation Name">
          {automation => automation.name}
        </Column>
        <Column<AutomationComplex> title="Created At">
          {automation => convertToLocaleDate(automation.createdAt)}
        </Column>
        <Column<AutomationComplex> title="Updated At">
          {automation => convertToLocaleDate(automation.updatedAt)}
        </Column>
        <Column<AutomationComplex> title="">
          {automation => (
            <TableButton
              editButton
              onClick={() => {}}
              srValue={automation.name}
            />
          )}
        </Column>
      </Table>
    </>
  )
}
